import actionTypes from '../constants/action-types';

const updateSiteData = (siteData) => ({
  type: actionTypes.UPDATE_SITE_DATA,
  payload: { siteData },
});

export default updateSiteData;
